import React from 'react';
import PropTypes from 'prop-types';
import DatasetModel from '../../../../models/pipeline/steps/dataset';
import ResultsTable from '../../../common/results_table';

export default function SingleInputQueryResult({dataset, showTable, adjacentToSelected, onClick}) {
    const sampleTable = dataset.getSampleTable();
    return (
        <>
            <div
                className={`query-result ${adjacentToSelected ? 'selected-step-adjacent' : ''}`}
                onClick={onClick}
            >
                <img src="images/query-result-icon.svg" alt="" />
                <div className="pipeline-step-text pipeline-highlight">
                    Query Results: {sampleTable.columns.length} columns
                </div>
            </div>
            {showTable && sampleTable && (
                <div className="query-result-table">
                    <ResultsTable
                        step={dataset}
                        data={sampleTable.getSampleData(false)}
                    />
                </div>
            )}
        </>
    );
}

SingleInputQueryResult.propTypes = {
    dataset: PropTypes.instanceOf(DatasetModel).isRequired,
    showTable: PropTypes.bool,
    adjacentToSelected: PropTypes.bool,
    onClick: PropTypes.func.isRequired,
};

SingleInputQueryResult.defaultProps = {
    showTable: false,
    adjacentToSelected: false,
};
